import React from "react";
import { History, MapPin, ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const fmt = (d) => new Date(d).toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });

export const RecentJobsDialog = ({ open, onClose, jobs, onJump }) => {
  const recent = [...jobs]
    .filter((j) => !j.is_unavailable && !j.is_hidden && j.created_at)
    .sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''))
    .slice(0, 10);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[85vh] flex flex-col" data-testid="recent-jobs-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <History className="h-5 w-5 text-[#605e5e]" />
            Recently Added Jobs
          </DialogTitle>
          <DialogDescription>The 10 newest jobs on the calendar — tap one to jump to it.</DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto space-y-1">
          {recent.map((job) => (
            <button
              key={job.id}
              onClick={() => onJump(job.date)}
              className="w-full text-left flex items-center gap-3 px-3 py-2 rounded-md border border-gray-100 hover:bg-gray-50 hover:border-[#8DA399]/50 transition-colors group"
              data-testid={`recent-job-${job.id}`}
            >
              <div className="flex-1 min-w-0">
                <p className="text-sm text-[#1f2937] truncate">{job.event_name || job.title}</p>
                <p className="text-[11px] text-[#8d8b8b] flex items-center gap-1.5 flex-wrap">
                  <span className="font-medium text-[#605e5e]">{fmt(job.date)}</span>
                  {job.location && (
                    <span className="inline-flex items-center gap-0.5"><MapPin className="h-2.5 w-2.5" />{job.location}</span>
                  )}
                  <span>· added {fmt(job.created_at)}</span>
                </p>
              </div>
              <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-[#8DA399] flex-shrink-0" />
            </button>
          ))}
          {recent.length === 0 && <p className="text-center text-sm text-[#8d8b8b] py-8">No jobs found</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
